class HttpService {
  async get(url: string | URL) {
    const response = await fetch(url, {method: 'GET'})
    return this.handleResponse(response)
  }

  async handleResponse(response: globalThis.Response) {
    const data = await response.json()
    if (response.ok === false) {
      throw new Error(response.statusText)
    }
    return data
  }

  async post(
    url: string | URL,
    headers: Record<string, string>,
    body: globalThis.BodyInit | null,
    signal?: AbortSignal
  ) {
    try {
      return fetch(url, {
        body,
        headers,
        method: 'post',
        signal
      })
    } catch (error) {
      console.log('Error: ', error)
    }
  }
}

export default new HttpService()
